<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="DED">To Caden Alexander and Emma Grace.</p>
<p class="DED">Love you to the moon and back.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?6b02a56b